document.addEventListener('DOMContentLoaded', () => {

  /*----------------------------------------
  Root URL
  ----------------------------------------*/
  // let rootUrl = window.rootUrl || '/';
  // if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
  //   rootUrl = window.Shopify.routes.root;
  // }
  // if (!rootUrl.endsWith('/')) {
  //   rootUrl += '/';
  // }
  // const rootUrl = window.Shopify?.routes?.root || '/';
  /*----------------------------------------
  Locale Root
  ----------------------------------------*/
  function getLocaleRoot() {

    const path = window.location.pathname;

    // zh-CN → zh に正規化
    if (path.startsWith('/zh')) {
      return '/zh/';
    }
    // en
    if (path.startsWith('/en')) {
      return '/en/';
    }
    // th
    if (path.startsWith('/th')) {
      return '/th/';
    }
    // fr
    if (path.startsWith('/fr')) {
      return '/fr/';
    }
    // es
    if (path.startsWith('/es')) {
      return '/es/';
    }
    // default
    return '/';
  }

  /*----------------------------------------
  Locale
  ----------------------------------------*/
  const getLocale = () => {
    const lang = (document.documentElement.lang || 'ja').toLowerCase();
    if (lang.startsWith('en')) return 'en';
    if (lang.startsWith('th')) return 'th';
    if (lang.startsWith('zh')) return 'zh';
    if (lang.startsWith('fr')) return 'fr';
    if (lang.startsWith('es')) return 'es';
    return 'ja';
  };

  /*----------------------------------------
  Texts
  ----------------------------------------*/
  const TEXTS = {
    ja: { adding: 'カートに追加中...', added: 'カートに追加しました', error: 'カート追加に失敗しました', mixed: 'デジタル商品と物理商品は同時に購入できません。\nお手数ですが、別々にご購入ください。' },
    en: { adding: 'Adding to cart...', added: 'Added to cart', error: 'Failed to add to cart', mixed: 'Digital products and physical products cannot be purchased together. Please purchase them separately.' },
    th: { adding: 'กำลังเพิ่มลงตะกร้า...', added: 'เพิ่มลงตะกร้าแล้ว', error: 'ไม่สามารถเพิ่มลงตะกร้าได้', mixed: 'สินค้าดิจิทัลและสินค้าจริงไม่สามารถซื้อพร้อมกันได้ โปรดซื้อแยกกัน' },
    zh: { adding: '正在加入购物车...', added: '已加入购物车', error: '加入购物车失败', mixed: '数字商品和实体商品无法同时购买。\n请您分别购买。' },
    fr: { adding: 'Ajout au panier...', added: 'Ajouté au panier', error: "Échec de l'ajout au panier", mixed: 'Il n’est pas possible d’acheter simultanément des produits numériques et des produits physiques. Veuillez les acheter séparément.' },
    es: { adding: 'Añadiendo al carrito...', added: 'Añadido al carrito', error: 'Error al añadir al carrito', mixed: 'No es posible comprar productos digitales y productos físicos al mismo tiempo. Le rogamos que los adquiera por separado.' }
  };

  /*----------------------------------------
  Mixed Cart Error Event
  ----------------------------------------*/
  window.addEventListener('mixed-cart-error', () => {
    document.querySelectorAll('.js-add-cart').forEach(btn => {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    });
  });

  /*----------------------------------------
  LP Add To Cart
  ----------------------------------------*/
  document.querySelectorAll('.js-add-cart').forEach(btn => {
    btn.addEventListener('click', async () => {

      if (btn.classList.contains('is-loading')) return;

      btn.classList.add('is-loading');
      btn.disabled = true;

      const variantId = Number(btn.dataset.variantId);
      const wrapper = btn.closest('.lp-cta__action');
      const status = wrapper?.querySelector('.js-cart-status');
      const locale = getLocale();
      const TEXT = TEXTS[locale];

      if (!variantId) {
        console.error('[LP Add Cart] Variant ID not found');
        if (status) status.textContent = TEXT.error;
        btn.disabled = false;
        btn.classList.remove('is-loading');
        return;
      }

      try {
        if (status) status.textContent = TEXT.adding;

        /*----------------------------------------
        Mixed Cart Validation
        ----------------------------------------*/
        if (typeof window.validateMixedCart === 'function') {
          const validation = await window.validateMixedCart(variantId);
          if (!validation.ok) {
            throw new Error('Mixed cart blocked');
          }
        }

        /*----------------------------------------
        Add Cart
        ----------------------------------------*/
        // const res = await fetch(`${rootUrl}cart/add.js`, {
        // const res = await fetch(`/cart/add.js`, {
        const localeRoot = getLocaleRoot();
        const res = await fetch(`${localeRoot}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        // if (!res.ok) throw new Error('Add cart failed');
        if (!res.ok) {
          const errorText = await res.text();
          console.error('[Cart Error]', errorText);
          throw new Error('Add cart failed');
        }
        if (status) status.textContent = TEXT.added;

        /*----------------------------------------
        Redirect Cart
        ----------------------------------------*/
        setTimeout(() => {
          // window.location.href = `${rootUrl}cart`;
          // window.location.href = `/cart`;
          // const cartUrl = `${window.location.origin}${window.Shopify.routes.root}cart`;
          const cartUrl = `${window.location.origin}${localeRoot}cart`;
          window.location.href = cartUrl;
        }, 300);

      } catch (e) {
        console.error(e);
        const isMixedError = e.message === 'Mixed cart blocked';
        if (status) {
          status.textContent = isMixedError ? TEXT.mixed : TEXT.error;
        }
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }
    });
  });

  // 画像モーダル（既存機能のまま）
  const mainImg = document.querySelector('.js-main-preview');
  const thumbs = document.querySelectorAll('.js-thumb');
  const thumbsWrapper = document.querySelector('.js-thumbs');
  const prevBtn = document.querySelector('.js-thumb-prev');
  const nextBtn = document.querySelector('.js-thumb-next');

  if (!thumbsWrapper) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      mainImg.src = thumb.dataset.full;
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  mainImg.addEventListener('click', () => {
    const modal = document.createElement('div');
    modal.className = 'lp-modal';
    modal.innerHTML = `<div class="lp-modal__bg"></div><img src="${mainImg.src}" class="lp-modal__img">`;
    document.body.appendChild(modal);
    modal.addEventListener('click', () => modal.remove());
  });

  const updateArrows = () => {
    const scrollLeft = thumbsWrapper.scrollLeft;
    const maxScroll = thumbsWrapper.scrollWidth - thumbsWrapper.clientWidth;
    if (scrollLeft > 5) prevBtn.classList.add('is-show'); else prevBtn.classList.remove('is-show');
    if (scrollLeft < maxScroll - 5) nextBtn.classList.add('is-show'); else nextBtn.classList.remove('is-show');
  };

  updateArrows();
  thumbsWrapper.addEventListener('scroll', updateArrows);
  window.addEventListener('resize', updateArrows);

  nextBtn.addEventListener('click', () => { thumbsWrapper.scrollBy({ left: 300, behavior: 'smooth' }); });
  prevBtn.addEventListener('click', () => { thumbsWrapper.scrollBy({ left: -300, behavior: 'smooth' }); });

});